<template>
  <div class="upper-limb-orthosis-step-three-b">
    <div class="content">
      <div class="img-container">
        <img src="@/assets/img/schema_oms_3b.svg">
        <v-text-field
          v-model="form.right_with_elbow_a"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Avec Coude) Droite A"
          :class="{ error: errors.has('(Schéma Avec Coude) Droite A') }"
          outlined
          type="number"
          style="top: 12.1%;left: 17%;"
          height="100%"
        />
        <v-text-field
          v-model="form.right_with_elbow_b"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Avec Coude) Droite B"
          :class="{ error: errors.has('(Schéma Avec Coude) Droite B') }"
          outlined
          type="number"
          style="top: 26.2%;left: 17%;"
          height="100%"
        />
        <v-text-field
          v-model="form.right_with_elbow_c"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Avec Coude) Droite C"
          :class="{ error: errors.has('(Schéma Avec Coude) Droite C') }"
          outlined
          type="number"
          style="top: 33.6%;left: 17%;"
          height="100%"
        />
        <v-text-field
          v-model="form.right_with_elbow_d"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Avec Coude) Droite D"
          :class="{ error: errors.has('(Schéma Avec Coude) Droite D') }"
          outlined
          type="number"
          style="top: 40.2%;left: 17%;"
          height="100%"
        />
        <v-text-field
          v-model="form.right_with_elbow_e"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Avec Coude) Droite E"
          :class="{ error: errors.has('(Schéma Avec Coude) Droite E') }"
          outlined
          type="number"
          style="top: 47.7%;left: 17%;"
          height="100%"
        />
        <v-text-field
          v-model="form.right_with_elbow_f"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Avec Coude) Droite F"
          :class="{ error: errors.has('(Schéma Avec Coude) Droite F') }"
          outlined
          type="number"
          style="top: 54.3%;left: 14.2%;"
          height="100%"
        />
        <v-text-field
          v-model="form.right_with_elbow_g"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Avec Coude) Droite G"
          :class="{ error: errors.has('(Schéma Avec Coude) Droite G') }"
          outlined
          type="number"
          style="top: 64.5%;left: 0.1%;"
          height="100%"
        />
        <v-text-field
          v-model="form.right_with_elbow_h"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Avec Coude) Droite H"
          :class="{ error: errors.has('(Schéma Avec Coude) Droite H') }"
          outlined
          type="number"
          style="top: 69.7%;left: 39.5%;"
          height="100%"
        />
        <v-text-field
          v-model="form.right_with_elbow_l"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Avec Coude) Droite L"
          :class="{ error: errors.has('(Schéma Avec Coude) Droite L') }"
          outlined
          type="number"
          style="top: 76.1%;left: 36.5%;"
          height="100%"
        />
        <v-text-field
          v-model="form.with_elbow_i"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Avec Coude) Droite I"
          :class="{ error: errors.has('(Schéma Avec Coude) Droite I') }"
          outlined
          type="number"
          style="top: 26.2%;left: 45%;"
          height="100%"
        />
        <v-text-field
          v-model="form.with_elbow_j"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Avec Coude) Droite J"
          :class="{ error: errors.has('(Schéma Avec Coude) Droite J') }"
          outlined
          type="number"
          style="top: 48.2%;left: 45%;"
          height="100%"
        />
        <v-text-field
          v-model="form.left_with_elbow_a"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Avec Coude) Gauche A"
          :class="{ error: errors.has('(Schéma Avec Coude) Gauche A') }"
          outlined
          type="number"
          style="top: 12.1%;left: 73.4%;"
          height="100%"
        />
        <v-text-field
          v-model="form.left_with_elbow_b"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Avec Coude) Gauche B"
          :class="{ error: errors.has('(Schéma Avec Coude) Gauche B') }"
          outlined
          type="number"
          style="top: 26.2%;left: 73.4%;"
          height="100%"
        />
        <v-text-field
          v-model="form.left_with_elbow_c"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Avec Coude) Gauche C"
          :class="{ error: errors.has('(Schéma Avec Coude) Gauche C') }"
          outlined
          type="number"
          style="top: 33.6%;left: 73.4%;"
          height="100%"
        />
        <v-text-field
          v-model="form.left_with_elbow_d"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Avec Coude) Gauche D"
          :class="{ error: errors.has('(Schéma Avec Coude) Gauche D') }"
          outlined
          type="number"
          style="top: 40.2%;left: 73.4%;"
          height="100%"
        />
        <v-text-field
          v-model="form.left_with_elbow_e"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Avec Coude) Gauche E"
          :class="{ error: errors.has('(Schéma Avec Coude) Gauche E') }"
          outlined
          type="number"
          style="top: 47.7%;left: 73.4%;"
          height="100%"
        />
        <v-text-field
          v-model="form.left_with_elbow_f"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Avec Coude) Gauche F"
          :class="{ error: errors.has('(Schéma Avec Coude) Gauche F') }"
          outlined
          type="number"
          style="top: 54.3%;left: 76%;"
          height="100%"
        />
        <v-text-field
          v-model="form.left_with_elbow_g"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Avec Coude) Gauche g"
          :class="{ error: errors.has('(Schéma Avec Coude) Gauche g') }"
          outlined
          type="number"
          style="top: 64.5%;left: 90%;"
          height="100%"
        />
        <v-text-field
          v-model="form.left_with_elbow_h"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Avec Coude) Gauche H"
          :class="{ error: errors.has('(Schéma Avec Coude) Gauche H') }"
          outlined
          type="number"
          style="top: 76.1%;left: 53.6%;"
          height="100%"
        />
        <v-text-field
          v-model="form.left_with_elbow_l"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Avec Coude) Gauche L"
          :class="{ error: errors.has('(Schéma Avec Coude) Gauche L') }"
          outlined
          type="number"
          style="top: 69.7%;left: 50.6%;"
          height="100%"
        />
        <v-text-field
          v-model="form.with_elbow_k"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Avec Coude) K"
          :class="{ error: errors.has('(Schéma Avec Coude) K') }"
          outlined
          type="number"
          style="top: 20.7%;left: 91.9%;"
          height="100%"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UpperLimbOrthosisStepThreeB",
  inject: ["parentValidator"],
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  created() {
    this.$validator = this.parentValidator;
  }
};
</script>

<style lang="scss">
.upper-limb-orthosis-step-three-b {
  .content {
    display: flex;
    min-height: 80vh;
    .img-container {
      position: relative;
      display: inline-block;
      margin: auto;
      img {
        height: 100%;
        width: 100%;
        min-width: 800px;
        @media (max-width: 800px) {
          min-width: auto;
        }
      }
      .v-input {
        position: absolute;
        width: 8%;
        height: 5.4%;
        @media (max-width: 800px) {
          height: 4.4%;
        }
        .v-input__control {
          height: 100%;
          .v-input__slot {
            min-height: auto;
          }
        }
      }
    }
  }
}
.minerve-step-three {
  .v-input--selection-controls {
    &.v-input {
      .v-input__control {
        flex-grow: 1;
      }
      .v-label {
        width: 100%;
      }
    }
    .v-input__slot {
      align-items: flex-start;
      .v-label {
        align-items: baseline;
      }
    }
  }
}
</style>
